import { Comment } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'

import type { Appointment } from '../../types.ts'
import Header from '../Header'

interface Props {
  appointment: Appointment
}

export const SectionSales = ({ appointment }: Props) => {
  if (!appointment.salesComment) return null
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      <Header label="Sales Information" />
      <Stack spacing={2}>
        <Box display="flex" alignItems="flex-start" gap={1}>
          <Comment color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Comment
            </Typography>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
            >
              {appointment.salesComment}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}

export default SectionSales
